// The 6 approved "table is ready" cowboy lines for the Dining Staff app.
// Staff either let it rotate automatically (round-robin, persisted per device)
// or pick one manually. Keep the array length at 6.
export const DINING_LINES = [
  "Howdy, partner! Your table's waitin' for ya!",
  "The chuckwagon has your grub ready, come and git it!",
  "Mosey on over to the barn, your tables awaitin'!",
  "Rustle up your posse, supper is ready!",
  "Dust off your boots and come on in—your spot's ready!",
  "Head 'em up, move 'em in—your reservation is ready.",
]

const ROTATE_KEY = 'dining_line_rotate_idx'

// Next line in the rotation (persists the index per device so it cycles).
export function nextRotatingLine() {
  let idx = 0
  try { idx = Number(localStorage.getItem(ROTATE_KEY)) || 0 } catch { /* ignore */ }
  const line = DINING_LINES[idx % DINING_LINES.length]
  try { localStorage.setItem(ROTATE_KEY, String((idx + 1) % DINING_LINES.length)) } catch { /* ignore */ }
  return line
}
